import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/client/components/careers/Careers.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/shared/ErrorFallback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/client/components/shared/hero/PageHero.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/shared/nav/Nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/client/components/shared/popup/AdmissionPopup.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/client/components/shared/ToastProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/client/components/shared/whatsapp-chat/WhatsApp-Chat.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/opt/build/repo/node_modules/.pnpm/next@14.2.35_@playwright+test@1.62.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/components/error-boundary.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/.pnpm/next@14.2.35_@playwright+test@1.62.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
